import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagTD(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAYUExURQQrav/PQf/MNQYzedobQNIYO8wVOMcTNouzHC8AAAE7SURBVDjL7Y8xdsMgEEQxnEDcAE4gRxdwYfUqtNRugNaVuH5mF6GnvIS4ibuMBCr+Zxap6ch1OHI/clP/wluFdb7zi60jVD5jLR3hyO21MDY+frnDvNK8Ihgx7jk3EDArhAZjJrM3OOcsqB0cM+G0NxjOVZhzgxuImrGgARUyozZYC4uOLKqdN+OHMMc7yEpSsyglAmt6cF4Ub88NU6XYLzy+OmdBGTUaGaS9Bf12h3oB1i7O80/IiEAUgQM9mKh6Ec2IH+cDhT18Se7nj7bes4MXhKJsDwAjDWrUjJl7D5hCjK1BpqABiCm0mKQhpvTg0/vSwrnFJ0lMMbIgwX9oOe45KVReG1q0r3HSEGrLT8Ix4r3C1tIRClBOW865IzDaSobVayglS7ZnR8i51Dy7DQUj8PwivGz4M+ETOtAIRUdjFREAAAAASUVORK5CYII=",
    alt: "TD"
  }, props));
}